<template>
  <!-- 上传作品组件 -->
  <el-dialog 
    title="上传作品" 
    :visible.sync="dialogFormVisible" 
    :show-close="true" 
    width="800px"  
    @close="handleCloseDialog"
    custom-class="edit-dialog" 
    :close-on-click-modal="false" >
    <el-form 
      :model="form" 
      :rules="rules" 
      ref="form" 
      label-width="150px" 
      class="edit-form"  
    >
      <!-- 文件上传（单独一行，与编辑对话框图片样式统一） -->
      <el-form-item label="作品截图" prop="workMedia" class="full-width-item ">
        <div class="img-upload-container">
          <el-upload
            class="avatar-uploader"
            :action="uploadImgUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-error="handleUploadError"
            :headers="headers"
          >
            <div class="img-preview-box">  <!-- 统一的图片预览容器 -->
              <img v-if="imageUrl" :src="imageUrl" class="avatar-img" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
          <div class="upload-tip">只能上传 JPG/PNG 文件，且不超过 2MB</div>
        </div>
      </el-form-item>

      <!-- 表单内容区域（分两行排列，与编辑对话框布局一致） -->
     
        <!-- 作品标题 -->
        <el-form-item label="作品名称" prop="workTitle" class="vertical-item">
          <el-input 
            v-model="form.workTitle" 
            placeholder="请输入作品名称" 
            class="full-width-input"
          />
        </el-form-item>

        <!-- 所属专业 -->
        <el-form-item label="所属专业" prop="majorId" class="vertical-item">
          <el-select 
            v-model="form.majorId" 
            placeholder="请选择专业"  
            @change="onMajorChange"
            class="form-select" 
          > 
            <el-option
              v-for="major in majorForm"
              :key="major.majorId"
              :label="major.majorName"
              :value="major.majorId"
            ></el-option>
          </el-select>
        </el-form-item>
      

        <!-- 学期选择 -->
        <el-form-item label="所属学期" prop="xueQi" class="vertical-item">
          <el-select 
            v-model="form.xueQi" 
            placeholder="请选择学期" 
            class="form-select"
          >
            <el-option
              v-for="(item, index) in 6"
              :key="index"
              :label="`第${index + 1}学期`"
              :value="`第${index + 1}学期`"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 阶段选择 -->
        <el-form-item label="所属学期阶段" prop="stage" class="vertical-item">
          <el-select 
            v-model="form.stage" 
            placeholder="请选择阶段" 
            class="form-select"
          >
            <el-option
              v-for="(item, index) in 8"
              :key="index"
              :label="`第${index + 1}阶段`"
              :value="index + 1"
            ></el-option>
          </el-select>
        </el-form-item>
      

      
        <!-- 创作日期 -->
        <el-form-item label="创作日期" size="normal" prop="workScreatetime" class="vertical-item">
          <el-date-picker
            v-model="form.workScreatetime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            class="form-picker"  
          ></el-date-picker>
        </el-form-item>
    
    </el-form>

    <!-- 底部按钮（与编辑对话框样式统一） -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="setPage" class="cancel-btn">取 消</el-button>
      <el-button type="primary" @click="setPahe1" class="confirm-btn">确 定</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
/* 作品名称输入框占满一行 */
.full-width-input {
  width: 50% !important;  /* 强制占满父容器宽度 */
  max-width: 300px;  /* 可选：限制最大宽度，避免过宽 */
  border-radius: 4px;
}


/* 复用编辑对话框的核心样式，确保风格统一 */
/* 弹窗整体样式 */
::v-deep .edit-dialog {
  border-radius: 8px;  /* 圆角边框 */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);  /* 柔和阴影 */
   /* 取消默认居中定位 */
  top: 0 !important;
  left: 30% !important;
  transform: translateX(-50%) !important;
  margin-top: 50px!important; /* 贴近顶部 */
}

/* 标题栏样式 */
::v-deep .edit-dialog .el-dialog__header {
  /* background-color: #ffe4e1;  钱粉色背景 */
  border-bottom: 1px solid #e6f4ff;
  padding: 15px 20px;
  border-radius: 8px 8px 0 0;  /* 顶部圆角 */
}

::v-deep .edit-dialog .el-dialog__title {
  /* color:#ff69b4;  标题文字色 */
  font-size: 16px;
  font-weight: 600;
}
/* 图片上传区域样式 */
.full-width-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 25px;
}

.img-upload-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;  /* 图片区域靠左，与编辑框一致 */
}

.img-preview-box {
  width: 400px;
  height: 225px;  /* 16:9比例，与编辑对话框图片尺寸统一 */
  border: 1px dashed #ccc;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.img-preview-box:hover {
  border-color: #ff69b4;  /* hover时边框变为主题色 */
  background-color: #fff0f5;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.avatar-uploader-icon {
  font-size: 32px;
  color: #999;
}

.upload-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}



/* 垂直排列的表单项样式 */
.vertical-item {
 
  margin-bottom: 20px !important;  /* 表单项之间的垂直间距 */
  width: 100%;  /* 确保占满一行宽度 */
  display:block
}
/* 强制表单项标签与内容对齐（解决下移问题） */
::v-deep .vertical-item .el-form-item__content {
  margin-top: 0 !important; /* 清除默认顶部间距，避免整体下移 */
}
/* 去除默认样式干扰 */
::v-deep .el-form-item {
  margin-bottom: 0;
}
/* 作品名称输入框占满一行 */
.full-width-input {
  width: 60% !important;
  max-width: 600px;  /* 限制最大宽度，避免过宽 */
  border-radius: 4px;
}

/* 输入控件样式统一 */
.form-input, .form-select, .form-picker {
  width: 300px !important;
  border-radius: 4px;
}

/* 按钮样式与编辑对话框统一 */
.dialog-footer {
  padding: 5px 20px 15px;  /* 上移20px，与编辑框按钮位置一致 */
  margin-top: -10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  border-radius: 4px;
}

.confirm-btn {
  background-color: #ff69b4;
  color: white;
  border: none;
  margin-left: 10px;
  border-radius: 4px;
}

::v-deep .confirm-btn:hover {
  background-color: #ff1493 !important;
  color: white !important;
}


</style>

<script>
import uploadmian from "@/js/uploadmian";
export default {
  ...uploadmian,
};
</script>